// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cache-warning {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  background: linear-gradient(135deg, #fff9e6 0%, #fff3cd 100%);
  border: 1px solid #ffd966;
  border-radius: 12px;
  padding: 16px 20px;
  margin-bottom: 20px;
  color: #8a6d3b;
  font-size: 14px;
  box-shadow: 0 2px 8px rgba(255, 197, 66, 0.15);
  position: relative;
  overflow: hidden;
  
  /* Плавная анимация появления */
  opacity: 0;
  transform: translateY(-10px);
  animation: cacheWarningSlideIn 0.4s ease-out forwards;
  
  /* Плавный переход для всех свойств */
  transition: all 0.3s ease-in-out;
}

.cache-warning-content {
  flex: 1 1;
  min-width: 0;
}

.cache-warning-title {
  font-weight: 600;
  font-size: 15px;
  margin-bottom: 4px;
  color: #8a6d3b;
}

.cache-warning-description {
  font-size: 14px;
  line-height: 1.4;
  color: #a17c3d;
  opacity: 0.9;
}

/* Анимация появления уведомления */
@keyframes cacheWarningSlideIn {
  0% {
    opacity: 0;
    transform: translateY(-10px);
  }
  70% {
    opacity: 0.8;
    transform: translateY(2px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Дополнительная анимация для привлечения внимания */
.cache-warning::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
  animation: cacheWarningShine 2s ease-in-out 0.5s;
}

@keyframes cacheWarningShine {
  0% {
    left: -100%;
  }
  50% {
    left: 100%;
  }
  100% {
    left: 100%;
  }
}

/* Адаптивность для мобильных устройств */
@media (max-width: 768px) {
  .cache-warning {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
    padding: 16px;
    
    /* Адаптивная анимация для мобильных */
    animation: cacheWarningSlideInMobile 0.4s ease-out forwards;
  }
  
  @keyframes cacheWarningSlideInMobile {
    0% {
      opacity: 0;
      transform: translateY(-8px) scale(0.98);
    }
    70% {
      opacity: 0.8;
      transform: translateY(1px) scale(1);
    }
    100% {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }
}


@keyframes cacheWarningIconPulse {
  0%, 100% {
    transform: translateY(-50%) scale(1);
  }
  50% {
    transform: translateY(-50%) scale(1.1);
  }
}

/* Плавное исчезновение при скрытии */
.cache-warning.hiding {
  animation: cacheWarningSlideOut 0.3s ease-in forwards;
}

@keyframes cacheWarningSlideOut {
  0% {
    opacity: 1;
    transform: translateY(0);
    max-height: 100px;
  }
  100% {
    opacity: 0;
    transform: translateY(-10px);
    max-height: 0;
    margin-bottom: 0;
    padding-top: 0;
    padding-bottom: 0;
  }
}

.cache-refresh-btn {
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid #d4a900;
  border-radius: 4px;
  padding: 6px 12px;
  font-size: 12px;
  font-weight: 500;
  color: #7a5c00;
  cursor: pointer;
  transition: all 0.2s ease;
  flex-shrink: 0;
  white-space: nowrap;
}

.cache-refresh-btn:hover:not(:disabled) {
  background: white;
  box-shadow: 0 1px 4px rgba(255, 165, 0, 0.4);
}

.cache-refresh-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./src/th-components/CacheWarning.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,6DAA6D;EAC7D,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,8CAA8C;EAC9C,kBAAkB;EAClB,gBAAgB;;EAEhB,+BAA+B;EAC/B,UAAU;EACV,4BAA4B;EAC5B,qDAAqD;;EAErD,qCAAqC;EACrC,gCAAgC;AAClC;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,YAAY;AACd;;AAEA,mCAAmC;AACnC;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,YAAY;IACZ,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,qDAAqD;AACrD;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,sFAAsF;EACtF,gDAAgD;AAClD;;AAEA;EACE;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA,yCAAyC;AACzC;EACE;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;IACT,aAAa;;IAEb,sCAAsC;IACtC,2DAA2D;EAC7D;;EAEA;IACE;MACE,UAAU;MACV,uCAAuC;IACzC;IACA;MACE,YAAY;MACZ,mCAAmC;IACrC;IACA;MACE,UAAU;MACV,iCAAiC;IACnC;EACF;AACF;;;AAGA;EACE;IACE,oCAAoC;EACtC;EACA;IACE,sCAAsC;EACxC;AACF;;AAEA,qCAAqC;AACrC;EACE,qDAAqD;AACvD;;AAEA;EACE;IACE,UAAU;IACV,wBAAwB;IACxB,iBAAiB;EACnB;EACA;IACE,UAAU;IACV,4BAA4B;IAC5B,aAAa;IACb,gBAAgB;IAChB,cAAc;IACd,iBAAiB;EACnB;AACF;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":[".cache-warning {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  background: linear-gradient(135deg, #fff9e6 0%, #fff3cd 100%);\n  border: 1px solid #ffd966;\n  border-radius: 12px;\n  padding: 16px 20px;\n  margin-bottom: 20px;\n  color: #8a6d3b;\n  font-size: 14px;\n  box-shadow: 0 2px 8px rgba(255, 197, 66, 0.15);\n  position: relative;\n  overflow: hidden;\n  \n  /* Плавная анимация появления */\n  opacity: 0;\n  transform: translateY(-10px);\n  animation: cacheWarningSlideIn 0.4s ease-out forwards;\n  \n  /* Плавный переход для всех свойств */\n  transition: all 0.3s ease-in-out;\n}\n\n.cache-warning-content {\n  flex: 1;\n  min-width: 0;\n}\n\n.cache-warning-title {\n  font-weight: 600;\n  font-size: 15px;\n  margin-bottom: 4px;\n  color: #8a6d3b;\n}\n\n.cache-warning-description {\n  font-size: 14px;\n  line-height: 1.4;\n  color: #a17c3d;\n  opacity: 0.9;\n}\n\n/* Анимация появления уведомления */\n@keyframes cacheWarningSlideIn {\n  0% {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  70% {\n    opacity: 0.8;\n    transform: translateY(2px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Дополнительная анимация для привлечения внимания */\n.cache-warning::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);\n  animation: cacheWarningShine 2s ease-in-out 0.5s;\n}\n\n@keyframes cacheWarningShine {\n  0% {\n    left: -100%;\n  }\n  50% {\n    left: 100%;\n  }\n  100% {\n    left: 100%;\n  }\n}\n\n/* Адаптивность для мобильных устройств */\n@media (max-width: 768px) {\n  .cache-warning {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 12px;\n    padding: 16px;\n    \n    /* Адаптивная анимация для мобильных */\n    animation: cacheWarningSlideInMobile 0.4s ease-out forwards;\n  }\n  \n  @keyframes cacheWarningSlideInMobile {\n    0% {\n      opacity: 0;\n      transform: translateY(-8px) scale(0.98);\n    }\n    70% {\n      opacity: 0.8;\n      transform: translateY(1px) scale(1);\n    }\n    100% {\n      opacity: 1;\n      transform: translateY(0) scale(1);\n    }\n  }\n}\n\n\n@keyframes cacheWarningIconPulse {\n  0%, 100% {\n    transform: translateY(-50%) scale(1);\n  }\n  50% {\n    transform: translateY(-50%) scale(1.1);\n  }\n}\n\n/* Плавное исчезновение при скрытии */\n.cache-warning.hiding {\n  animation: cacheWarningSlideOut 0.3s ease-in forwards;\n}\n\n@keyframes cacheWarningSlideOut {\n  0% {\n    opacity: 1;\n    transform: translateY(0);\n    max-height: 100px;\n  }\n  100% {\n    opacity: 0;\n    transform: translateY(-10px);\n    max-height: 0;\n    margin-bottom: 0;\n    padding-top: 0;\n    padding-bottom: 0;\n  }\n}\n\n.cache-refresh-btn {\n  background: rgba(255, 255, 255, 0.9);\n  border: 1px solid #d4a900;\n  border-radius: 4px;\n  padding: 6px 12px;\n  font-size: 12px;\n  font-weight: 500;\n  color: #7a5c00;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  flex-shrink: 0;\n  white-space: nowrap;\n}\n\n.cache-refresh-btn:hover:not(:disabled) {\n  background: white;\n  box-shadow: 0 1px 4px rgba(255, 165, 0, 0.4);\n}\n\n.cache-refresh-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
